import { openDataUriInNewTab } from "./PopupInvoicePrinting";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

const getAdjuntoIcon = (titulo = "") => {
  const ext = titulo.split(".").pop().toLowerCase();
  return IMAGE_EXTENSIONS.includes(ext)
    ? "/images/gallery-blue.svg"
    : "/images/doc-blue.svg";
};

export default ({ titulo, fichero, onRemove }) => {
  return (
    <div className="popup-email-adjunto-chip">
      <div
        className="popup-email-adjunto-open c-pointer"
        onClick={() => fichero && openDataUriInNewTab(fichero, titulo)}
      >
        <img
          src={getAdjuntoIcon(titulo)}
          loading="lazy"
          alt=""
          className="popup-email-adjunto-icon"
        />
        <span className="popup-email-adjunto-title">{titulo}</span>
      </div>
      <img
        src="/images/close-dark.svg"
        loading="lazy"
        alt=""
        className="c-pointer popup-email-adjunto-remove"
        onClick={onRemove}
      />
    </div>
  );
};
